import React from 'react';

const MenuCategoryCard = ({ categoryName, onClick }) => {
    const icons = { /* ... icon mapping ... */
        antipasti: '🧀', Pizzor: '🍕', "Pasta (Färsk Pasta)": '🍝', "Insalate – Sallader – Salads": '🥗', "Secondi Piatti – Carni/Pesce – A la carte": '🥩', "Italiensk Sandwich (panini)": '🥪', "Barn meny": '👶', "Dolci (desserter)": '🍰', Tillbehör: '🧂', Vino: '🍷', Birra: '🍺', Fatöl: '🍺', Flaska: '🍾', Cider: '🍹', "Lätt & Alkoholfritt": '💧', Drinkar: '🍸', Kaffe: '☕', "Kaffe Drinkar": '☕', "Läsk / vatten": '🥤', "Avec / Snaps": '🥃'
    };
    const normalizedCategoryName = Object.keys(icons).find(key => key.toLowerCase() === categoryName.toLowerCase()) || categoryName;
    const icon = icons[normalizedCategoryName] || '🍽️';

    return (
        <div
            onClick={onClick}
            className="bg-white p-5 shadow-md hover:shadow-lg rounded-xl cursor-pointer
                       border border-gray-100 hover:bg-amber-50 hover:border-amber-400
                       transition-all duration-300 ease-in-out transform hover:-translate-y-1
                       flex flex-col justify-center items-center text-center min-h-[120px] group"
        >
            <div className="text-3xl mb-2 text-red-700 group-hover:text-green-700 transition-colors duration-300">{icon}</div>
            <h3 className="text-lg font-serif font-semibold text-stone-800 group-hover:text-red-700 transition-colors duration-300">{categoryName}</h3>
        </div>
    );
};

export default MenuCategoryCard;